import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { IAllergen } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { ProductInfoModal } from 'featureSliced/widgets/Modals/ProductInfoModal'
import { useGetTranslatedNames } from '../../useGetTranslatedNames'

export type ProductInfoTarget = {
  id: number
  categoryId: number
  title?: string
  hasProductInfo?: boolean
  allergens?: IAllergen[]
  allergenLabels?: string[]
  note?: string | null
}

export type OpenProductInfoType = (
  target: ProductInfoTarget,
  options?: { withCatalogueSections?: boolean }
) => void

export const useOpenProductInfoModal = (): OpenProductInfoType => {
  const t = useTranslations()
  const openModal = useOpenModal()
  const { getProductName } = useGetTranslatedNames()

  const openProductInfo: OpenProductInfoType = (target, options) => {
    const withCatalogueSections = options?.withCatalogueSections === true
    openModal({
      id: 'PRODUCT_INFO_SHEET',
      title: getProductName(target) || t('productInfo.title'),
      components: [
        () => (
          <ProductInfoModal
            categoryId={target.categoryId}
            productId={target.id}
            fetchDetails={
              withCatalogueSections ? target.hasProductInfo === true : true
            }
            withCatalogueSections={withCatalogueSections}
            allergens={target.allergens}
            allergenLabels={target.allergenLabels}
            note={target.note}
          />
        ),
      ],
    })
  }

  return openProductInfo
}
